var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PRO-icon",
    clipPath: "url(#clip0_15695_96156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star 4 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57606 8.60967C9.45736 8.97495 9.11706 9.22226 8.73296 9.22226H3.61526C2.75646 9.22226 2.39946 10.3212 3.09416 10.826L7.23456 13.8344C7.54526 14.0602 7.67526 14.4603 7.55656 14.8256L5.97506 19.6933C5.70976 20.5101 6.64446 21.1893 7.33926 20.6845L11.4796 17.6761C11.7903 17.4504 12.211 17.4504 12.5217 17.6761L16.6621 20.6845C17.3568 21.1893 18.2916 20.5101 18.0262 19.6933L16.4448 14.8256C16.3261 14.4603 16.4561 14.0602 16.7668 13.8344L20.9071 10.826C21.6019 10.3212 21.2448 9.22226 20.3861 9.22226H15.2683C14.8843 9.22226 14.5439 8.97495 14.4252 8.60967L12.8438 3.742C12.5784 2.92521 11.423 2.9252 11.1576 3.742L9.57606 8.60967ZM16.5565 6.56258L15.3731 2.92012C14.3116 -0.347057 9.68976 -0.347085 8.62826 2.92012L7.44486 6.56258L3.61526 6.56259C0.180262 6.56259 -1.24804 10.9585 1.53096 12.9778L4.62916 15.2289L3.44576 18.8714C2.38436 22.1386 6.12346 24.8555 8.90246 22.8362L12.0007 20.5851L15.0989 22.8362C17.8779 24.8554 21.617 22.1386 20.5555 18.8714L19.3721 15.2289L22.4703 12.9778C25.2493 10.9585 23.8211 6.56259 20.3861 6.56259L16.5565 6.56258Z",
    fill: "#1C2A34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 5",
    d: "M11.1629 3.74199C11.4282 2.92519 12.5837 2.9252 12.8491 3.74199L14.4305 8.60966C14.5492 8.97494 14.8896 9.22225 15.2736 9.22225H20.3914C21.2501 9.22225 21.6072 10.3212 20.9124 10.826L16.7721 13.8344C16.4614 14.0602 16.3314 14.4603 16.4501 14.8256L18.0315 19.6933C18.2969 20.5101 17.3621 21.1893 16.6674 20.6845L12.527 17.6761C12.2163 17.4503 11.7956 17.4503 11.4849 17.6761L7.34462 20.6845C6.64982 21.1893 5.71502 20.5101 5.98042 19.6933L7.56192 14.8256C7.68052 14.4603 7.55052 14.0602 7.23982 13.8344L3.09952 10.826C2.40482 10.3212 2.76182 9.22225 3.62062 9.22225H8.73832C9.12232 9.22225 9.46272 8.97494 9.58142 8.60966L11.1629 3.74199Z",
    fill: "url(#paint0_linear_15695_96156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 40",
    d: "M12.0004 5.83057L10.4499 10.5049H5.27539",
    stroke: "#F7FCFD",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 41",
    d: "M8.6381 15.9644L7.7793 18.4991",
    stroke: "#F7FCFD",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15695_96156",
    x1: 25.0021,
    y1: 18.9564,
    x2: -0.393678,
    y2: 0.641286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43A1C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15695_96156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProIcon);
export default __webpack_public_path__ + "static/media/PRO-icon.1e89bbc9b290e3daedd6c5bf32bc5d36.svg";
export { ForwardRef as ReactComponent };